import { render, staticRenderFns } from "./year.vue?vue&type=template&id=36f125cc&scoped=true&lang=html"
import script from "./year.vue?vue&type=script&lang=js"
export * from "./year.vue?vue&type=script&lang=js"
import style0 from "./year.vue?vue&type=style&index=0&id=36f125cc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f125cc",
  null
  
)

export default component.exports